import { SCHEDULE_ENV_CONFIG_KEYS } from './consts';
import { getBaseScheduleUrl } from './getBaseScheduleUrl';

/**
 * Get the base URL for the schedule BE service.
 */
export const getBaseScheduleBEUrl = () =>
  getBaseScheduleUrl(SCHEDULE_ENV_CONFIG_KEYS.SCHEDULE_BE);
